import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Grid } from "../../core/components/grid";
import { Helper } from "../../core/util/helper";
import { AppHelper } from "../../appHelper";
import { Config } from "../../core/config/config";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { TextBox } from "../../core/components/textBox";
import { Label, LabelProps } from "../../core/components/label";
import { ComponentHelper } from "../../core/util/componentHelper";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Baraus, CashExpenseContext } from "./cashExpense";
import React from "react"
export default class EditLanguageSpecificParameters extends React.Component<EditLanguageSpecificParametersProps, EditLanguageSpecificParametersState>{
    common = new AppHelper();
    gridOptions: {} = null;
    private _fullLoaded: boolean;
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {

                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false }, this._updateValues);
        },
        width: 500
    };

    constructor(props: EditLanguageSpecificParametersProps) {
        super(props);
        this._fullLoaded = false;
        this.state = {
            dialogOpen: false,
            values: props.value,
            buttonEnabled: {
                likeUserLanguage: Helper.hasValue(props.entity.OriginalDescription),
                likeSelectedLanguage: false
            },
            selectedItem: null
        };
    }

    componentDidMount() {
        this.gridOptions = this.props.context.languageSpezificGridOptions;
        this._setEvents();
        this._fullLoaded = true;
        this.setState({});
    }

    private _updateValues = () => {
        const updatedItem = this.state.selectedItem;
        let values = this.state.values;
        for (let i = 0; i < values.length; i++) {
            if (values[i].Language.Id === updatedItem.Language.Id) {
                values[i] = updatedItem;
                break;
            }
        }
        this.setState({ values: values }, this._elementChanged);
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createLanguageLabel()}
                        {this._createTextBox("Name")}
                        {this._createTextBox("Unit")}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createLanguageLabel = () => {
        let props: LabelProps = this._factory.getDefaultLabelProps();
        props.value = this.state.selectedItem.Language.Name;
        return (
            <FieldInstance label={Helper.getTranslation("Sprachen.Sprache")} noHover={true} >
                <Label {...props} />
            </FieldInstance>
        );
    }

    private _createTextBox = (value: "Name" | "Unit") => {
        let props = this._factory.getDefaultTextBoxProps();
        let label = "";

        switch (value) {
            case "Name":
                label = Helper.getTranslation("Standard.Name");
                props.value = Helper.getValueOrDefault(this.state.selectedItem.TemplateName, "");
                props.field.maxLength = 25;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.selectedItem;
                    item.TemplateName = value;
                    this.setState({ selectedItem: item });
                }
                break;
            case "Unit":
                label = Helper.getTranslation("Field.Barauslage.Unit");
                props.value = Helper.getValueOrDefault(this.state.selectedItem.Unit, "");
                props.field.maxLength = 4;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.selectedItem;
                    item.Unit = value;
                    this.setState({ selectedItem: item });
                }
                break;
        }
        return (
            <FieldInstance label={label} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );

    }

    private _elementChanged = () => {
        let newEntity = this.props.entity;
        newEntity.Translations = this.state.values;
        Helper.updateEntity(this.props.entity, newEntity);
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "cashExpenseLanguageSpezificValueChanged" });
    }

    private _openDialog = (dataItem: CashExpenseTranslation) => {
        this.setState({
            dialogOpen: true,
            selectedItem: dataItem
        });
    }

    private _createGrid = () => {
        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });

            const customButtons: Array<GridCustomToolBarButton> = [];
            customButtons.push({
                id: "likeUserLanguage", enabled: this.state.buttonEnabled.likeUserLanguage, caption: Helper.getTranslation("WebSMS.UserSettings.MainGroup.FillWithUser"), autoEnabledOnRecordSelected: false, iconClass: "far fa-user"
            });
            customButtons.push({
                id: "likeSelectedLanguage", enabled: this.state.buttonEnabled.likeUserLanguage, caption: Helper.getTranslation("WebSMS.UserSettings.MainGroup.FillWithSelect"), autoEnabledOnRecordSelected: true, iconClass: "fas fa-language"
            });
            customButtons.push({
                id: "deleteNames", enabled: true, caption: Helper.getTranslation("WebSMS.UserSettings.MainGroup.DeleteNames"), autoEnabledOnRecordSelected: false, iconClass: "fas fa-ban"
            });

            let grid = (
                <Grid data={this.state.values} options={this.gridOptions} id="generalSettings_CacheExpenses_LanguageSpecificParameters"
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                    customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton}
                    onSelectionChanged={this.handleSelectionChanged} />
            );
            return (grid)
        } else {
            return (<></>);
        }
    }

    handleSelectionChanged = (dataItem: CashExpenseTranslation) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({
                buttonEnabled: {
                    likeSelectedLanguage: Helper.hasValue(dataItem.TemplateName),
                    likeUserLanguage: Helper.hasValue(this.props.entity.OriginalDescription)
                }
            });
        }
    }

    handleClickCustomButton = (id: string, dataItem: any, dataItems: Array<any>) => {
        switch (id) {
            case "likeUserLanguage":
                this._fillAlllanguages({ Language: null, TemplateName: this.props.entity.OriginalDescription, Unit: this.props.entity.Unit });
                break;
            case "likeSelectedLanguage":
                this._fillAlllanguages(dataItem);
                break;
            case "deleteNames":
                this._deleteAllLanguages();
                break;
        }
        this._elementChanged();
    }

    private _fillAlllanguages = (dataItem: CashExpenseTranslation) => {
        let values = this.state.values;
        for (let i = 0; i < values.length; i++) {
            if (Helper.isNullOrEmpty(values[i].TemplateName)) {
                values[i].TemplateName = dataItem.TemplateName;
            }
            if (Helper.isNullOrEmpty(values[i].Unit)) {
                values[i].Unit = dataItem.Unit;
            }
        }
        this.setState({ values: values });
    }

    private _deleteAllLanguages = () => {
        let values = this.state.values;
        for (let i = 0; i < values.length; i++) {
            values[i].TemplateName = null;
            values[i].Unit = null;
        }
        this.setState({ values: values });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this._openDialog(dataItem);
        }
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus: { command: string, value: any }) => {
            if (cus.command === "cashExpenseTemplateNameChanged") {
                this.setState({
                    buttonEnabled: {
                        likeSelectedLanguage: false,
                        likeUserLanguage: !Helper.isNullOrEmpty(cus.value)
                    }
                });
            }
        });
    }

    private getWarningLabel = () => {
        const labelStyle: React.CSSProperties = {
            color: "#ff0000",
            whiteSpace: "pre-wrap"
        }
        var text = Helper.getTranslation("Field.Barauslage.SameTranslations") + "\n" + Helper.getTranslation("Field.Barauslage.SameMeaning");
        return <label style={labelStyle}>{text}</label>
    }


    render() {
        const warningLabel = this.getWarningLabel();
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <>
                {warningLabel}
                {grid}
                {dialog}
            </>
        );
    }
}

interface EditLanguageSpecificParametersProps {
    context: CashExpenseContext;
    value: CashExpenseTranslation[];
    entity: Baraus;
}

interface EditLanguageSpecificParametersState {
    dialogOpen: boolean;
    values: CashExpenseTranslation[];
    buttonEnabled: {
        likeUserLanguage: boolean;
        likeSelectedLanguage: boolean;
    };
    selectedItem: CashExpenseTranslation;
}
export interface CashExpenseTranslation {
    Language: LanguageId;
    TemplateName: string;
    Unit: string;
}

interface LanguageId {
    Id: number;
    Name: string;
}